class MenuUser {
    [x: string]: any;
 	 static $inject = ['$stateParams','ModalService','PermPermissionStore','Router','UsersAlertPendingService'];
    constructor($stateParams, ModalService, PermPermissionStore, Router, UsersAlertPendingService) {
        this.params = $stateParams;
        this.ModalService = ModalService;
        this.PermPermissionStore = PermPermissionStore;
        this.router = Router;
        this.UsersAlertPendingService = UsersAlertPendingService;
    }

    $onInit() {
        this.UsersAlertPendingService.onInit();
    }

    $onDestroy() {
        this.UsersAlertPendingService.onDestroy();
    }

    onInvitingNewUser() {
        this.userLimitReached()
            ? this.showUsersLimitAlert()
            : this.goToInvitationPanel();
    }

    userLimitReached() {
        return this.userStats && this.userStats.pendingCount + this.userStats.activeCount >= this.userStats.limit
    }

    goToInvitationPanel() {
      this.router.navigateByUrl('/users/active/invite/new');
    }

    isPending() {
        return this.UsersAlertPendingService.isPending();
    }

}

export default {
    controller: MenuUser,
    template : require('./menu.users.html'),
    bindings: {find: '&', userStats: '<', showUsersLimitAlert: "&"}
};
